import { render, staticRenderFns } from "./nutritionalProductsPage.vue?vue&type=template&id=8cd92c9e&"
import script from "./nutritionalProductsPage.vue?vue&type=script&lang=js&"
export * from "./nutritionalProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports